import { Utilities as utilities } from "@truckdown/framework";

export class ThrottleRatios {
    constructor(json?: any) {
        if (json) {
            this.minCount = utilities.json.getNumberValue(json, 'min_count', 0);
            if (json.max_count) {
                this.maxCount = json.max_count as number;
            }
            if (json.max_parent) {
                this.maxRatioParent = json.max_parent as number;
            }
            if (json.max_child) {
                this.maxRatioChild = json.max_child as number;
            }
            if (json.limit_parent) {
                this.limitRatioParent = json.limit_parent as number;
            }
            if (json.limit_child) {
                this.limitRatioChild = json.limit_child as number;
            }
            if (json.suspect_parent) {
                this.suspectRatioParent = json.suspect_parent as number;
            }
            if (json.suspect_child) {
                this.suspectRatioChild = json.suspect_child as number;
            }
        }
    }

    toJSON() {
        return {
            min_count: this.minCount,
            max_count: this.maxCount,
            max_parent: this.maxRatioParent,
            max_child: this.maxRatioChild,
            limit_parent: this.limitRatioParent,
            limit_child: this.limitRatioChild,
            suspect_parent: this.suspectRatioParent,
            suspect_child: this.suspectRatioChild
        };
    }

    minCount: number = 0;
    maxCount?: number;

    maxRatioParent?: number;
    maxRatioChild?: number;
    limitRatioParent?: number;
    limitRatioChild?: number;
    suspectRatioParent?: number;
    suspectRatioChild?: number;
}